const SCROLL_RETRY_DELAYS_MS = [0, 0, 50, 150, 150, 200];

export function scrollToScheduleMatch(
  matchId: number,
  options?: { behavior?: ScrollBehavior }
): boolean {
  const el = document.querySelector<HTMLElement>(`[data-match-id="${matchId}"]`);
  if (!el) return false;

  el.scrollIntoView({
    block: 'center',
    inline: 'center',
    behavior: options?.behavior ?? 'smooth',
  });

  return true;
}

/** Retry scroll until the match mounts (virtualization / day switch) or attempts exhaust. */
export function scrollToScheduleMatchWithRetry(
  matchId: number,
  options?: { behavior?: ScrollBehavior; onComplete?: (found: boolean) => void }
): void {
  let attempt = 0;

  const run = () => {
    if (scrollToScheduleMatch(matchId, options)) {
      options?.onComplete?.(true);
      return;
    }
    attempt += 1;
    if (attempt >= SCROLL_RETRY_DELAYS_MS.length) {
      options?.onComplete?.(false);
      return;
    }
    window.setTimeout(run, SCROLL_RETRY_DELAYS_MS[attempt]);
  };

  run();
}
